<div class="pagination-red career-pagination">
  <div
    class="d-flex align-items-center justify-content-center gap-3 flex-wrap mb-3"
  >
    <div class="d-flex align-items-center">
      <span class="me-2">Találatok / oldal</span>
      <select
        class="form-select form-select-sm w-auto"
        [ngModel]="limit"
        (ngModelChange)="onLimitChange($event)"
      >
        <option *ngFor="let opt of pageSizeOptions" [value]="opt">
          {{ opt }}
        </option>
      </select>
    </div>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a
          class="page-link"
          href="#"
          (click)="changePage(currentPage - 1); $event.preventDefault()"
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>

      <li
        class="page-item"
        *ngFor="let p of pages"
        [class.active]="p === currentPage"
      >
        <a
          class="page-link"
          href="#"
          (click)="changePage(p); $event.preventDefault()"
        >
          {{ p }}
        </a>
      </li>

      <li
        class="page-item"
        [class.disabled]="currentPage === totalPages"
      >
        <a
          class="page-link"
          href="#"
          (click)="changePage(currentPage + 1); $event.preventDefault()"
          aria-label="Next"
        >
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</div>

